export class CallerConstant {

    // HTTP Headers
    public static HTTPHeaders = {
        Authorization: {
            Key: 'Authorization'
        },
        ContentType: {
            Key: 'Content-Type',
            Value: 'application/json'
        },
        Accept: {
            Key: 'Accept',
            Value: 'application/json'
        }
    }

}
